import React, { useState } from 'react';
import Flickity from 'react-flickity-component';

import './Gallery.scss';

const Gallery = ({
    imagesArray,
    onClick,
    carouselStyles,
    carouselCellStyles,
}) => {
    const _externalOnClick = onClick;
    const flickityOptions = {
        adaptiveHeight: true,
        draggable: false,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: imagesArray.length > 1,
    };

    const _carouselStyles = carouselStyles === undefined ? {} : carouselStyles;
    const _carouselCellStyles = (i) => {
        return carouselCellStyles === undefined
            ? {
                  width: imagesArray.length > 1 ? '' : '100%',
                  height: 'auto',
                  cursor:
                      i.url === undefined || i.url === ''
                          ? 'default'
                          : 'pointer',
              }
            : carouselCellStyles;
    };

    const carousel = imagesArray.map((i, idx) => (
        <img
            key={idx}
            className='carousel-cell'
            style={_carouselCellStyles(i)}
            src={i.image}
            onClick={(e) => {
                if (_externalOnClick !== undefined) {
                    return _externalOnClick(e, idx);
                } else {
                    e.preventDefault();
                    if (i.url !== undefined && i.url !== '')
                        window.location.href = i.url;
                    return false;
                }
            }}></img>
    ));
    return (
        <div className='gallery' style={_carouselStyles}>
            <Flickity options={flickityOptions}>{carousel}</Flickity>
        </div>
    );
};

export default Gallery;
